import { cn } from '@/lib/cn';

/** Neutral stand-in creative (test mode / Vitest / screenshots). Never a real brand or logo. */
export function AdPlaceholder({ className, label = 'Ad', note = 'Test creative', rounded = 'rounded-[12px]' }: { className?: string; label?: string; note?: string; rounded?: string }) {
  return (
    <div
      className={cn('flex min-h-[100px] w-full flex-col items-center justify-center gap-1 border border-dashed border-line bg-raised px-4 py-6 text-center', rounded, className)}
      data-testid="ad-placeholder"
      aria-label={`${label} placeholder`}
    >
      <span className="text-[13px] font-semibold text-fg">{label}</span>
      <span className="text-[13px] text-muted">{note}</span>
    </div>
  );
}
